<div class="page_title">
    <div class="container-fluid">
        <div class="row">
            <div class="col-auto mt-2">
                <k-button [type]="KButtonType.KLAiMSButton" [label]="'Back'" [color]="'brand-main'"
                    [icon]="{type: 'kennedys', name: 'back-arrow'}" (buttonClick)="goToPage()">
                </k-button>
            </div>
            <div class="col">
                <h3>Audiogram Comparison</h3>
                <app-custom-breadcrumb *ngIf="customData" [data]="customData"></app-custom-breadcrumb>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid">
    <div class="pages_space">
        <div class="row audiogram_comparison_search mb-3">
            <div class="col-md-12">
                <form name="searchAudiogramFilterForm" [formGroup]="searchAudiogramFilterForm" #formDir="ngForm">
                    <div class="row search_section">
                        <div class="col col-md-4 col-lg-3 pr-lg-0">
                            <input type="text" class="form-control rounded-0" formControlName="keyword"
                                placeholder="Search" />
                        </div>
                        <div class="col-auto ">
                            <div class="k_button_holder">
                                <k-button [type]="KButtonType.KLAiMSButton" [label]="'Search'" [color]="'brand-main'"
                                    (buttonClick)="submit_searchAudiogramFilterForm($event, searchAudiogramFilterForm)">
                                </k-button>
                                <k-button [type]="KButtonType.KLAiMSButton" [color]="'brand-main'"
                                    [icon]="{type: 'fas', name: 'undo'}"
                                    (buttonClick)="reset_searchAudiogramFilterForm(searchAudiogramFilterForm)">
                                </k-button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row" *ngIf="allAudiometryTests.length == 0">
            <div class="col-12 searchResults">
                <span *ngIf="filter">No audiograms found with the keyword
                    <b>{{filter.searchKeyword}}</b><br></span>
            </div>
        </div>

        <div class="comparison_flex row">
            <div #stickySaveBar class="col-8 col-sm-6 col-md-4 col-lg-3 col-xl-2 sticky-top comparison_flex_left">
                <div class="comparison_flex_scroll" *ngIf="allAudiometryTests.length > 0">

                    <div class="comparisonList comparisonMainList">
                        <table class="table comparisonList_tbl">
                            <tbody>
                                <tr *ngFor="let eachData of allAudiometryTests; let i = index">
                                    <td
                                        *ngIf="eachData['audiometryType'] != 'average' && eachData['audiometryType'] != 'composite'">
                                        <b>{{eachData['type']}}</b><br>
                                        <span class="field-text text-truncate">
                                            <span placement="top" ngbTooltip="Date of Test">
                                                {{eachData['audiogramDate'] | date:'dd/MM/yyyy'}}
                                            </span>
                                        </span>
                                    </td>
                                    <td
                                        *ngIf="eachData['audiometryType'] != 'average' && eachData['audiometryType'] != 'composite'">

                                        <div class="form-check form-switch iQswitch">
                                            <input class="form-check-input" type="checkbox" role="switch"
                                                [checked]="checkedAudiogram(eachData,i)" id="{{eachData['_id']}}"
                                                (click)="selectAudiogram(eachData, $event)">
                                            <label class="form-check-label" for="{{eachData['_id']}}">&nbsp;</label>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="comparisonList avgComposList avgCompToggle">
                    <table class="table comparisonList_tbl">
                        <tbody>
                            <tr>
                                <td>
                                    <b>Averaged</b><br>
                                    <span class="field-text text-truncate">
                                        <span placement="top" ngbTooltip="Date of Test">
                                            --
                                        </span>
                                    </span>
                                </td>
                                <td>

                                    <div class="form-check form-switch iQswitch">
                                        <input class="form-check-input" type="checkbox" [checked]="isAvgChecked"
                                            id="average" (click)="selectAverageOrComposite('average', $event)">
                                        <label class="form-check-label" for="average">&nbsp;</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <b>Composite</b><br>
                                    <span class="field-text text-truncate">
                                        <span placement="top" ngbTooltip="Date of Test">
                                            --
                                        </span>
                                    </span>
                                </td>
                                <td>

                                    <div class="form-check form-switch iQswitch">
                                        <input class="form-check-input" type="checkbox" role="switch"
                                            [checked]="isCompChecked" id="composite"
                                            (click)="selectAverageOrComposite('composite', $event)">
                                        <label class="form-check-label" for="composite">&nbsp;</label>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            <div class="col-12 col-md comparison_flex_main">
                <div class="main_1" *ngIf="allAudiometryTests.length > 0">
                    <div class="row h-100">
                        <div class="col-12 col-lg-6 h-100 pe-0 ps-0">
                            <div class="audioInfoBox graph_box h-100 text-center">
                                <h4 class="audiogram_title">Right</h4>
                                <app-chart [dataset]="linesRight" [legendOnClick]="legendOnClick()"></app-chart>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 pe-0 ps-0 h-100">
                            <div class="audioInfoBox graph_box h-100 text-center">
                                <h4 class="audiogram_title">Left</h4>
                                <app-chart [dataset]="linesLeft" [legendOnClick]="legendOnClick()"></app-chart>
                            </div>
                        </div>
                        <div class="colorpickerWrap  colorchangeboth">
                            <span class="colorPic_center">
                                <div class="form-inline d-flex align-items-center justify-content-center flex-wrap">
                                    <ng-container *ngFor="let label of chartLabelsForArhlRight">
                                        <div class="form-group my-2 mx-2">
                                            <label for="colorPickArhlR" class="me-2 label_colorPick"> {{
                                                label.title }}</label>
                                            <input type="color" class="form-control-plaintext" [value]="label.color"
                                                (input)="changeColor($event, label.id, 'arhlR',  label._id)" />
                                        </div>
                                    </ng-container>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>


                <div class="main2 avgCompDataWrap">
                    <h3 class="text-center mb-2">{{this.chartType.toUpperCase()}}</h3>
                    <div class="row h-100">
                        <div class="col-12 col-lg-6 h-100">
                            <div class="audioInfoBox graph_box h-100 text-center">
                                <h4 class="audiogram_title">Right</h4>
                                <app-chart [dataset]="linesRightAvg"></app-chart>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 h-100">
                            <div class="audioInfoBox graph_box h-100 text-center">
                                <h4 class="audiogram_title">Left</h4>
                                <app-chart [dataset]="linesLeftAvg"></app-chart>
                            </div>
                        </div>
                    </div>
                    <div class="audioInfoBox table_box">
                        <app-table name="Right" [data]="rightAvgCompData?.table"></app-table>
                        <app-table name="Left" [data]="leftAvgCompData?.table"></app-table>
                        <div class="w-100 text-end">
                            <k-button [type]="KButtonType.KLAiMSButton"
                                [label]="'Save as New Audiometry'" [color]="'brand-main'" (buttonClick)="open(content)">
                            </k-button>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<k-simple-alert [display]="displaySuccess" [msgType]="'success'" [message]="successText"
    [timeout]="timeout"></k-simple-alert>
<k-simple-alert [display]="displayError" [msgType]="'error'" [message]="errorText" [timeout]="timeout"></k-simple-alert>

<!-- Modal -->
<ng-template #content let-modal>
    <div class="modal-header">
        <p>A new audiometry will be saved as </p>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div>
            <h4 id="modal-basic-title" class="mb-3">{{this.chartType.toUpperCase()}}</h4>
            <p>Result of the <b>{{this.chartType}}</b> values from these readings:</p>
            <div class="selectedAudList">
                <div class="row selectedAudList_margin">
                    <div class="col-5"><b>Audiometry Type</b></div>
                    <div class="col-4"><b>Date of Audiometry</b></div>
                    <div class="col-3"><b>Tinnitus Level</b></div>
                </div>
                <div *ngFor="let selected_aud_id of this.audiogramIds">
                    <div *ngFor="let aud_id of this.allAudiometryTests">
                        <div class="row selectedAudList_margin" *ngIf="selected_aud_id == aud_id['_id']">
                            <div class="col-5"><b>{{aud_id['type']}} :</b></div>
                            <div class="col-4">{{aud_id['audiogramDate'] | date:'dd/MM/yyyy'}}</div>
                            <div class="col-3">{{aud_id['tinnitus'] }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h6 class="mb-3 mt-3">Tinnitus Level</h6>
                </div>
                <div class="col-6">
                    <select class="form-select rounded-0" (change)="tinnitusOnChange($event)">
                        <option *ngFor="let tc of tinnitusConditionsList" [value]="tc"
                            [selected]="tc == tinnitusCondition">{{tc}}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn-dark-grey klaim_btn text-center" (click)="modal.close('Cancel click')">
            Cancel</button>
        <button type="button" class="btn-brand-main klaim_btn text-center"
            (click)="submit_saveAsNewAudiometry(this.audiogramIds, rightAvgCompData, leftAvgCompData, this.chartType)">
            Create Audiometry</button>

    </div>
</ng-template>
<!-- Modal End -->